import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { MenuIconButton } from '@hub-mono/ui';

const ConfirmTooltipButton = props => {
    const { onConfirm, buttonText, icon = 'moreVert', variant = 'text', dataCyPrefix } = props;

    const options = useMemo(() => {
        return [
            {
                label: buttonText,
                onClick: onConfirm,
                dataCy: `${dataCyPrefix}-confirm-button`,
            },
        ];
    }, [buttonText, dataCyPrefix, onConfirm]);

    return (
        <MenuIconButton
            density={-4}
            variant={variant}
            dataCy={`${dataCyPrefix}-elipsis-button`}
            icon={icon}
            options={options}
        />
    );
};

ConfirmTooltipButton.propTypes = {
    onConfirm: PropTypes.func.isRequired,
    className: PropTypes.string,
    buttonText: PropTypes.string,
    color: PropTypes.oneOf(['danger', 'info', 'secondary', 'success', 'warning', 'primary', 'link']),
};

ConfirmTooltipButton.defaultProps = {
    buttonText: 'Confirm',
    color: '',
    className: 'btn-hub-core-simple-hover',
};

export default ConfirmTooltipButton;
